import type { CSSProperties } from 'react';
import styles from './MainView.module.css';
import type { ILaunchViewProps as ILaunchViewProperties } from './interface';

export enum StyleElement {
    Container = 'Container',
    BackgroundImage = 'BackgroundImage',
    ProgressBar = 'ProgressBar',
    LoadingIcon = 'LoadingIcon',
    ImageIcon = 'ImageIcon',
    TextStatus = 'TextStatus',
    TextDetail = 'TextDetail',
}

const DEFAULTS: Record<StyleElement, CSSProperties> = {
    [StyleElement.Container]: {},
    [StyleElement.BackgroundImage]: {},
    [StyleElement.ProgressBar]: {},
    [StyleElement.LoadingIcon]: {},
    [StyleElement.ImageIcon]: {},
    [StyleElement.TextStatus]: {},
    [StyleElement.TextDetail]: {},
};

const PROPS_APPLICATOR: Record<StyleElement, (properties: ILaunchViewProperties) => CSSProperties> =
    {
        [StyleElement.Container]: (properties: ILaunchViewProperties) => ({
            backgroundColor: properties.model.backgroundColor,
        }),
        [StyleElement.BackgroundImage]: (properties: ILaunchViewProperties) => ({}),
        [StyleElement.ProgressBar]: (properties: ILaunchViewProperties) => ({
            backgroundColor: properties.model.progressBar.backgroundColor,
            opacity: properties.model.progressBar.visible ? 1 : 0,
            pointerEvents: properties.model.progressBar.visible ? 'auto' : 'none',
        }),
        [StyleElement.LoadingIcon]: (properties: ILaunchViewProperties) => ({
            color: properties.model.status.color,
        }),
        [StyleElement.ImageIcon]: (properties: ILaunchViewProperties) => ({}),
        [StyleElement.TextStatus]: (properties: ILaunchViewProperties) => ({
            color: properties.model.status.color,
            fontWeight: properties.model.status.fontWeight,
            fontFamily: properties.model.status.fontFamily,
            fontSize: properties.model.status.fontSize,
            lineHeight: properties.model.status.fontSize,
            opacity: properties.model.status.visible ? 1 : 0,
        }),
        [StyleElement.TextDetail]: (properties: ILaunchViewProperties) => ({
            color: properties.model.detail.color,
            fontWeight: properties.model.detail.fontWeight,
            fontFamily: properties.model.detail.fontFamily,
            fontSize: properties.model.detail.fontSize,
            lineHeight: properties.model.detail.fontSize,
            opacity: properties.model.detail.visible ? 1 : 0,
        }),
    };

export function classNameForElement(element: StyleElement, model: ILaunchViewProperties): string {
    const name = element.toString();
    return styles[name] ?? '';
}

export function styleForElement(
    element: StyleElement,
    properties: ILaunchViewProperties,
): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](properties) };

    return style;
}
